import { ApiGraphqlTypes as AGT, nzApiClient } from '@nizza/core';
import { AddToCart, AddToCartProvider } from '../../domain';

export class GraphqlAddToCartProvider implements AddToCartProvider {
  async sendAddToCart(data: AddToCart): Promise<void> {
    const { sendAddToCart } = await nzApiClient.graphql(
      AGT.SendAddToCartDocument,
      {
        data: {
          id: data.id,
          account: data.account,
          idEvent: data.idEvent,
          email: data.email,
          isMobile: data.isMobile,
          orderFormId: data.orderFormId,
          sectionFromWhereItWasAdded: data.sectionFromWhereItWasAdded,
          productId: data.productId,
          productName: data.productName,
          productImageUrl: data.productImageUrl,
          sessionId: data.sessionId,
        },
      },
    );

    this.propagateGraphqlErrorIfExists(sendAddToCart as AGT.AddToCartResult);
  }

  private propagateGraphqlErrorIfExists(res: AGT.AddToCartResult) {
    if (res.message === 'ErrorGeneral') throw new Error();
  }
}
